export default "__VITE_ASSET__e30f000f__"